import styled from "styled-components";

const DiscountPopupWrapper = styled.div`
  .p-dialog-title {
    color: #6b47f5;
  }
  .p-button {
    background-color: #6b47f5;
    color: #fff;
    border-color: #6b47f5;
    padding: 10px 30px;

    &:hover {
      background-color: #4f46e5;
      border-color: #4f46e5;
    }
  }

  .closeText {
    padding-top: 7px;
    font-size: 13px !important;
    font-weight: 700;
  }
  .p-dialog-footer {
    text-align: center;
  }
  .listContent {
    list-style: none;
    font-weight: 400;
    font-size: 13px;
    color: #4c565c;
    margin-top: 30px;
    padding-left: 0px;

    li {
      display: flex;
      align-items: flex-start;
    }
  }
  .listContent-rtl {
    list-style: none;
    font-weight: 400;
    font-size: 13px;
    color: #4c565c;
    margin-top: 30px;
    padding-right: 0px;

    li {
      display: flex;
      align-items: flex-start;
    }
  }
  .iconStyle {
    padding-right: 12px;
  }
  .iconStyle-rtl {
    padding-left: 12px;
  }
  .secondaryListItem {
    padding-left: 32px;
  }
  .primaryListItem {
    padding-bottom: 9px;
  }
  .container-fluid {
    text-align: initial;
  }
  .linePadding {
    padding-left: 50px;
  }
  .headerIcon1 {
  }
  .headerTitle {
    font-size: 24px;
    font-weight: 700;
    color: #6b47f5;
  }
  .headerTitle-stc {
    font-size: 24px;
    font-weight: 700;
    color: #4f008c;
  }
`;

export default DiscountPopupWrapper;
